import { render, staticRenderFns } from "./CategoryFinder.vue?vue&type=template&id=2d62d2e2&"
import script from "./CategoryFinder.vue?vue&type=script&lang=js&"
export * from "./CategoryFinder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports